<template>
  <v-layout
    class="patient-page"
    column
    style="background-color:#525659"
  >
  <resend-request-dialog ref="resendRequest"/>
    <v-toolbar color="white" flat>
      <v-toolbar-title>{{this.requestID}}</v-toolbar-title>
    <v-spacer></v-spacer>
    <v-btn
          @click="goToHelp()"
          outline
          color="blue"
        >Help</v-btn>
    <v-btn
          @click="viewPatient()"
          outline
          color="green"
        >View Patient</v-btn>
        <v-menu offset-y>
          <v-btn color="primary" dark slot="activator">
            Actions
          </v-btn>
        <v-list>
          <v-list-tile @click="markError()">
            <v-list-tile-title>Mark Error</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="cancelRequest()">
            <v-list-tile-title>Cancel Request</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="resendRequest()">
            <v-list-tile-title>Resend Request</v-list-tile-title>
          </v-list-tile>
          <v-list-tile @click="completeRequest()">
            <v-list-tile-title>Mark Complete</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-divider></v-divider>
    <iframe frameBorder="0" style="height: 100%; width: 100%;" :src="requestURL"/>
    <request-logs/>
  </v-layout>
</template>

<script>
import Titlebar from '@/components/Titlebar'
import { mapActions, mapState } from 'vuex'
import DataCard from '@/components/cards/DataCard'
import InformationCard from '@/components/cards/InformationCard'
import HelperMixin from '@/core/mixins/HelperMixin'
import AddEditProviderDialog from '@/components/dialogs/AddEditProviderDialog'
import dateFormat from 'date-fns/format'
import bus from '@/core/helpers/bus'
import ResendRequestDialog from '@/components/dialogs/ResendRequestDialog'
import RequestLogs from '@/components/RequestLogs'

export default {
  mixins: [HelperMixin],
  components: {
    Titlebar,
    DataCard,
    AddEditProviderDialog,
    InformationCard,
    ResendRequestDialog,
    RequestLogs
  },
  data() {
    return {
      logEntryInput: null,
      updatingLog: false,
      publicNote: false,
      requestID: null,
      placesID: null,
      suggestedProvider: {
        googlePlaceID: '',
        type: '',
        firstName: '',
        lastName: '',
        credentials: '',
        specialization: '',
        organizationName: '',
        coveredEntityName: '',
        address: {
          line1: '',
          line2: '',
          city: '',
          state: '',
          zip: ''
        },
        phone: '',
        fax: '',
        email: '',
        notes: ''
      },
      numberOfPatients: null,
      smartChoiceCount: null,
      grayhawkCount: null,
      imagineMDCount: null,
      smartChoiceToday: null,
      smartChoice7Days: null,
      smartChoiceThisMonth: null,
      smartChoiceUserCount: null,
      smartChoiceUsersThisMonth: [],
      smartChoiceUsers: [],
      oneChartUsers: [],
      oneChartPatients: [],
      nonPartnerPatients: [],
      userCreatorsOfNonPartnerPatients: [],
      userPatientMatch: [],
      userIDsOfCreatorsOfPatients: [],
      patientCreatorUsers: [],
      nonPatientCreatorUsers: [],
      smartChoiceUsersLastMonth: [],
      smartChoiceUsersLastWeek: [],

      // Request field values
      requestField: {
        line1: {
          input: null,
          rules: [v => !!v || 'Street Address is required'],
          label: 'Street Address'
        },
        line2: {
          input: null,
          label: 'PO Box, Apt'
        },
        city: {
          input: null,
          rules: [v => !!v || 'City is required'],
          label: 'City'
        },
        state: {
          input: null,
          rules: [v => this.stateValidation.includes(v) || 'Invalid State'],
          label: 'State',
          mask: 'AA'
        },
        zip: {
          input: null,
          rules: [v => !!v || 'Zip Code is required'],
          label: 'Zip'
        },
        fax: {
          input: null,
          label: 'Fax Number',
          mask: '(###) ###-####'
        },
        phone: {
          input: null,
          label: 'Phone Number',
          mask: '(###) ###-####'
        },
        email: {
          input: null,
          label: 'Email Address'
        }
      },

      // Provider field values
      providerField: {
        name: null
      },

      stateValidation: [
        'AL',
        'AK',
        'AS',
        'AZ',
        'AR',
        'CA',
        'CO',
        'CT',
        'DE',
        'DC',
        'FM',
        'FL',
        'GA',
        'GU',
        'HI',
        'ID',
        'IL',
        'IN',
        'IA',
        'KS',
        'KY',
        'LA',
        'ME',
        'MH',
        'MD',
        'MA',
        'MI',
        'MN',
        'MS',
        'MO',
        'MT',
        'NE',
        'NV',
        'NH',
        'NJ',
        'NM',
        'NY',
        'NC',
        'ND',
        'MP',
        'OH',
        'OK',
        'OR',
        'PW',
        'PA',
        'PR',
        'RI',
        'SC',
        'SD',
        'TN',
        'TX',
        'UT',
        'VT',
        'VI',
        'VA',
        'WA',
        'WV',
        'WI',
        'WY'
      ]
    }
  },
  methods: {
    ...mapActions('admin', [
      'getPatientList',
      'getUserList',
      'getRequest',
      'getRequestProvider',
      'setStatus',
      'sendRequest',
      'getRequestOverrides',
      'submitRequestOverrides',
      'submitRequestNote',
      'getDocumentFiles'
    ]),
    goToHelp() {
      window.open('https://docs.google.com/document/d/1CfJaWj19kJcKLPTLPNvOU-2uveJkTth6vxcqNZ8Z7dk/edit?usp=sharing')
    },
    ...mapActions('provider', ['getProviderIDFromGooglePlacesID']),
    toast(type, text) {
      bus.$emit('toast', { type, text })
    },
    viewProvider() {
      console.log(this.request)
    },
    viewNPIDetails() {
      window.open('https://api.pverify.com/NPILOOKUP/NPI/NPIDetails/' + this.formatProviderNPI(this.request))
    },
    viewInGoogleMaps() {
      window.open('https://www.google.com/maps/place/?q=place_id:' + this.formatProviderGooglePlacesURL(this.request))
    },
    viewPatient() {
      window.open('https://patient.onecharthealth.com/#/patients/' + this.request.patient)
    },
    viewRequest() {
      window.open('https://api.onecharthealth.com/requests/' + this.requestID + '?alt=media')
    },
    publicNoteToggle() {
      if (this.publicNote) {
        this.publicNote = false
      } else {
        this.publicNote = true
      }
    },
    populateProviderFields() {
      const address = this.requestProviderOverrides.providerAddressOverride
      for (let key in this.requestField) {
        if (!this.requestField.hasOwnProperty(key)) continue
        this.requestField[key].input = address[key]
      }

      this.requestField.email.input = this.requestProviderOverrides.providerEmailOverride
      this.requestField.fax.input = this.requestProviderOverrides.providerFaxOverride
      this.requestField.phone.input = this.requestProviderOverrides.providerPhoneOverride
      this.providerField.name = this.requestProviderOverrides.providerNameOverride
    },
    submitRequestChanges() {
      if (
        this.requestProviderOverrides.providerEmailOverride !==
        this.requestField.email.input
      ) {
        if (
          this.requestField.email.input !== null &&
          this.requestField.email.input.length === 0
        ) {
          this.requestField.email.input = null
        }
      }
      if (
        this.requestProviderOverrides.providerFaxOverride !==
        this.requestField.fax.input
      ) {
        if (
          this.requestField.fax.input !== null &&
          this.requestField.fax.input.length === 0
        ) {
          this.requestField.fax.input = null
        }
      }
      if (
        this.requestProviderOverrides.providerPhoneOverride !==
        this.requestField.phone.input
      ) {
        if (
          this.requestField.phone.input !== null &&
          this.requestField.phone.input.length === 0
        ) {
          this.requestField.phone.input = null
        }
      }

      const prov = {
        name: this.providerField.name,
        address: {
          line1: this.requestField.line1.input,
          line2: this.requestField.line2.input,
          city: this.requestField.city.input,
          state: this.requestField.state.input,
          zip: this.requestField.zip.input
        },
        email: this.requestField.email.input,
        fax: this.requestField.fax.input,
        phone: this.requestField.phone.input
      }
      this.submitRequestOverrides({ id: this.requestID, provider: prov })
        .then(() => {
          this.toast('success', 'Request Updated')
          if (this.checkIfRequestInformationComplete()) {
            this.setStatus({
              id: this.request.id,
              status: {
                status: 'SENDING'
              }
            }).then(() => {
              this.getRequest(this.requestID)
            })
          }
        })
        .catch(error => {
          this.toast('error', error)
          return error
        })
    },
    checkNeedsNull(key, changedVal) {
      if (changedVal !== this.requestField[key].input) {
        if (
          this.requestField &&
          this.requestField[key] &&
          this.requstField[key].input &&
          this.requestField[key].input.length === 0
        ) {
          this.requestField[key].input = null
        }
      }
    },
    updateProvider() {
      const vm = this
      vm.getRequestProvider(vm.requestID).then(() => {
        this.toast('success', 'Provider Updated')
      })
    },
    openPlacesID() {
      let url =
        'https://www.google.com/maps/search/?api=1&query=Google&query_place_id=' +
        this.placesID
      window.open(url)
    },
    editProvider() {
      this.$refs.addEditProviderDialog.open({
        id: this.request.provider.id,
        provider: this.request.provider
      })
    },
    convertDate(timestamp) {
      let d = new Date(timestamp * 1000)
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear()
    },
    cancelRequest() {
      this.setStatus({
        id: this.request.id,
        status: {
          status: 'CANCELLED'
        }
      })
        .then(data => {
          this.getRequest(this.requestID)
          this.toast('success', 'Request Cancelled')
        })
        .catch(error => {
          this.toast('error', error)
          return error
        })
    },
    markError() {
      this.setStatus({
        id: this.request.id,
        status: {
          status: 'ERROR'
        }
      })
        .then(data => {
          this.getRequest(this.requestID)
          this.toast('success', 'Request Errored')
        })
        .catch(error => {
          this.toast('error', error)
          return error
        })
    },
    completeRequest() {
      this.setStatus({
        id: this.request.id,
        status: {
          status: 'COMPLETED'
        }
      })
        .then(data => {
          this.getRequest(this.requestID)
          this.toast('success', 'Request Completed')
        })
        .catch(error => {
          this.toast('error', error)
          return error
        })
    },
    resendRequest() {
      this.$refs.resendRequest.open({
        request: this.request
      })
    },
    resendRequestActual() {
      if (this.requestProviderOverrides.providerFaxOverride || this.requestProviderOverrides.providerEmailOverride) {
        this.sendRequest({ id: this.requestID }).then(data => {
          this.setStatus({
            id: this.requestID,
            status: {
              status: 'SENDING'
            }
          })
            .then(() => {
              this.getRequest(this.requestID)
              this.toast('success', 'Request Sent')
            })
            .catch(error => {
              this.toast('error', error)
              return error
            })
        })
      }
    },
    submitLogEntry() {
      this.updatingLog = true
      let email = ''
      if (this.user) {
        if (this.user.email) {
          email = '(' + this.user.email + ')'
        }
      }
      let unix = Math.round(+new Date() / 1000)
      if (this.logEntryInput !== '' && this.logEntryInput !== null) {
        this.submitRequestNote({
          id: this.requestID,
          notes: this.request.log,
          note: { timestamp: unix, message: this.logEntryInput + ' ' + email }
        }).then(data => {
          this.updatingLog = false
          this.logEntryInput = null
          this.publicNote = false
          this.getRequest(this.requestID)
          this.toast('success', 'Note Submitted')
        })
      } else {
        this.updatingLog = false
        this.toast('error', 'Note not Submitted')
      }
    },
    convertDateToDaysInProgress(timestamp) {
      let d = new Date(timestamp * 1000)
      var oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds
      var firstDate = d
      var secondDate = new Date()

      var diffDays = Math.round(
        Math.abs((firstDate.getTime() - secondDate.getTime()) / oneDay)
      )

      return diffDays
    },
    formatGoogleProviderName(provider) {
      if (provider) {
        if (provider.firstName) {
          return (
            provider.firstName +
            ' ' +
            provider.lastName +
            ' ' +
            provider.credentials
          )
        } else if (provider.organizationName) {
          return provider.organizationName
        }
      } else {
        return 'Provider Error'
      }
    },
    formatGoogleProviderAddress(provider) {
      if (provider) {
        if (provider.address) {
          return (
            provider.address.line1 +
            ' ' +
            provider.address.city +
            ' ' +
            provider.address.state +
            ' ' +
            provider.address.zip
          )
        }
      } else {
        return 'Provider Error'
      }
    },
    formatProviderName(item) {
      if (item.provider) {
        if (item.provider.firstName) {
          return (
            item.provider.firstName +
            ' ' +
            item.provider.lastName +
            ' ' +
            item.provider.credentials
          )
        } else if (item.provider.organizationName) {
          return item.provider.organizationName
        }
      } else if (item.missingProviderInfo) {
        return 'Needs Attention'
      } else {
        return 'Provider Error'
      }
    },
    formatProviderAddress(item) {
      if (item.provider) {
        if (item.provider.address) {
          return (
            item.provider.address.line1 +
            ' ' +
            item.provider.address.city +
            ' ' +
            item.provider.address.state +
            ' ' +
            item.provider.address.zip
          )
        }
      } else if (item.missingProviderInfo) {
        return 'Needs Attention'
      } else {
        return 'Provider Error'
      }
    },
    formatPatientAddress(item) {
      if (item.patient) {
        if (item.patient.address) {
          if (!item.patient.address.line2) {
            return (
              item.patient.address.line1 +
              ' ' +
              item.patient.address.city +
              ' ' +
              item.patient.address.state +
              ' ' +
              item.patient.address.zip
            )
          } else {
            return (
              item.patient.address.line1 +
              ' ' +
              item.patient.address.line2 +
              ' ' +
              item.patient.address.city +
              ' ' +
              item.patient.address.state +
              ' ' +
              item.patient.address.zip
            )
          }
        }
      } else if (item.missingProviderInfo) {
        return 'Needs Attention'
      } else {
        return 'Provider Error'
      }
    },
    formatProviderFax(item) {
      if (item.provider) {
        if (item.provider.fax) {
          return item.provider.fax
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    formatProviderEmail(item) {
      if (item.provider) {
        if (item.provider.email) {
          return item.provider.email
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    formatProviderPhone(item) {
      if (item.provider) {
        if (item.provider.phone) {
          return item.provider.phone
        } else {
          return ''
        }
      } else {
        return ''
      }
    },
    formatProviderNPI(item) {
      if (item.provider) {
        if (item.provider.npi) {
          if (item.provider.npi != null) {
            return item.provider.npi
          }
        }
      }
      return null
    },
    formatProviderGooglePlacesURL(item) {
      if (item.provider) {
        if (item.provider.googlePlaceID) {
          if (item.provider.googlePlaceID != null) {
            return item.provider.googlePlaceID
          }
        }
      }
      return null
    },
    formatPartnerName(item) {
      if (item.partner) {
        return item.partner
      } else {
        return 'Consumer'
      }
    },
    formatPatientName(item) {
      if (item.patient) {
        if (item.patient.firstName) {
          return item.patient.firstName + ' ' + item.patient.lastName
        } else {
          return 'Click View Patient'
        }
      } else {
        return 'Click View Patient'
      }
    },
    formatPatientBirthdate(item) {
      if (item.patient) {
        if (item.patient.birthdate) {
          return this.convertDate(item.patient.birthdate)
        } else {
          return 'Click View Patient'
        }
      } else {
        return 'Click View Patient'
      }
    },
    exportDataSet(dataSet) {
      let csvContent = 'data:text/csv;charset=utf-8,'
      csvContent += dataSet.join(',\n')
      let encodedUri = encodeURI(csvContent)
      window.open(encodedUri)
    },
    createUserPatientMatch() {
      if (
        this.userSearchResults &&
        this.userIDsOfCreatorsOfPatients.length > 0
      ) {
        this.userSearchResults.forEach(user => {
          if (!this.userIDsOfCreatorsOfPatients.includes(user.id)) {
            if (!this.patientCreatorUsers.includes(user)) {
              this.patientCreatorUsers.push(user)
            }
          } else {
            if (!this.nonPatientCreatorUsers.includes(user)) {
              this.nonPatientCreatorUsers.push(user)
            }
          }
        })
      }
    },
    goToDocumentPage(id) {
      this.$router.push({
        name: 'AdminDocumentPage',
        params: { id }
      })
    },
    checkIfRequestInformationComplete() {
      if (this.request.status === 'MISSING_INFO') {
        // Checking if the provider has a name, address info, and either email or fax
        if (
          this.request.provider &&
          this.request.provider.firstName &&
          this.request.provider.lastName &&
          this.request.provider.address &&
          this.request.provider.address.city &&
          this.request.provider.address.line1 &&
          this.request.provider.address.state &&
          this.request.provider.address.zip &&
          (this.request.provider.email || this.request.provider.fax)
        ) {
          // Fields are valid to send
          return true
        }
        // If the fields are not valid
        return false
      }
      // If the status is not MISSING_INFO continue
      return true
    },
    TEST_SET_BROKEN_REQUEST() {
      const prov = {
        name: this.providerField.firstName + ' ' + this.providerField.lastName,
        address: {
          line1: this.requestField.line1.input,
          line2: this.requestField.line2.input,
          city: this.requestField.city.input,
          state: this.requestField.state.input,
          zip: this.requestField.zip.input
        },
        email: this.requestField.email.input,
        fax: null,
        phone: this.requestField.phone.input
      }
      this.submitRequestOverrides({ id: this.requestID, provider: prov })
        .then(() => {
          this.toast('success', 'Request Updated')
        })
        .catch(error => {
          this.toast('error', error)
          return error
        })

      this.setStatus({
        id: this.request.id,
        status: {
          status: 'MISSING_INFO'
        }
      })
    },
    parseTimestamp(timestamp) {
      const ts = new Date(parseInt(timestamp) * 1000)
      return dateFormat(ts, 'MMM D YYYY HH:MM:ss Z')
    },
    alternatingColors(index) {
      if (index % 2 === 0) {
        return 'whiteAlternate'
      } else {
        return 'grayAlternate'
      }
    }
  },
  computed: {
    ...mapState('admin', [
      'patientSearchResults',
      'userSearchResults',
      'request',
      'files'
    ]),
    ...mapState('auth', ['user']),
    requestURL() {
      return 'https://api.onecharthealth.com/requests/' + this.requestID + '?alt=media'
    },
    requestProviderOverrides() {
      // this is a replacement for the call
      let objectToReturn = {
        id: this.request.id,
        providerAddressOverride: this.request.providerAddressOverride,
        providerFaxOverride: this.request.providerFaxOverride,
        providerEmailOverride: this.request.providerEmailOverride,
        providerPhoneOverride: this.request.providerPhoneOverride,
        providerNameOverride: this.request.providerNameOverride
      }
      return objectToReturn
    },
    publicProviderButtonName() {
      if (this.publicNote) {
        return 'Make Private'
      } else {
        return 'Make Public'
      }
    },
    logStamps() {
      let logStrings = []
      let sortedLogs = this.request.log

      sortedLogs.sort(function(a, b) {
        a = new Date(parseInt(a.timestamp) * 1000)
        b = new Date(parseInt(b.timestamp) * 1000)
        return a > b ? -1 : a < b ? 1 : 0
      })
      sortedLogs.forEach(element => {
        let stamp = element.timestamp
        const ts = new Date(parseInt(stamp) * 1000)
        let stampString = dateFormat(ts, 'MMM D YYYY HH:MM:ss Z')
        let message = element.message

        let messageHere = message

        let fullString = stampString + ' ' + messageHere
        logStrings.push(fullString)
      })
      return logStrings
    },
    providerInformation() {
      let providerInformation = {}

      providerInformation.title = 'Provider Information'
      if (this.request) {
        providerInformation.data = [
          {
            title: 'Name',
            data: this.formatProviderName(this.request)
          },
          {
            title: 'Address',
            data: this.formatProviderAddress(this.request)
          },
          {
            title: 'MR Phone',
            data: this.formatProviderPhone(this.request)
          },
          {
            title: 'MR Fax',
            data: this.formatProviderFax(this.request)
          },
          {
            title: 'MR Email',
            data: this.formatProviderEmail(this.request)
          },
          {
            title: 'Google Places ID',
            data: this.formatProviderGooglePlacesURL(this.request)
          },
          {
            title: 'Provider Note',
            data: this.request.provider.notes
          }
        ]
      } else {
        return null
      }
      return providerInformation
    },
    requestInformation() {
      let requestInformation = {}
      requestInformation.title = 'Request Information'
      requestInformation.data = [
        {
          title: 'Date Requested',
          data: this.convertDate(this.request.created)
        },
        (requestInformation.data = {
          title: 'Dates of Service',
          data: this.convertDate(this.request.start)
        }),
        (requestInformation.data = {
          title: 'Status',
          data: this.request.status
        })
      ]
      return requestInformation
    },
    patientInformation() {
      let patientInformation = {}
      patientInformation.title = 'Patient Information'
      patientInformation.data = [
        {
          title: 'Name',
          data: this.formatPatientName(this.request)
        },
        (patientInformation.data = {
          title: 'Date of birth',
          data: this.formatPatientBirthdate(this.request)
        }),
        (patientInformation.data = {
          title: 'Address',
          data: this.formatPatientAddress(this.request)
        })
      ]
      return patientInformation
    }
  },
  watch: {
    request(val) {
      if (this.request) {
        if (this.request.missingProviderInfo && !this.request.provider) {
          if (this.request.missingProviderInfo.includes(':')) {
            let placesIDArray = this.request.missingProviderInfo.split(':')
            this.placesID = placesIDArray[1]
            // this is a google places request. we should see if a provider exists with this information.
            // look up provider by google places ID
            this.getProviderIDFromGooglePlacesID({
              googlePlaceIDs: [this.placesID]
            }).then(data => {
              // this will either return a provider with data or create a blank provider to put data in.
              // the request does neet to be updated with this provider.
              var statusToSet = 'NEEDS_FAX_NUMBER'
              if (data.fax) {
                statusToSet = 'SENDING'
              }
              this.setStatus({
                id: this.request.id,
                status: {
                  provider: data[0]._id,
                  status: statusToSet
                }
              }).then(data => {
                this.getRequest(this.requestID)
              })
            })
          }
        } else if (this.request.missingProviderInfo) {
          if (this.request.missingProviderInfo.includes(':')) {
            let placesIDArray = this.request.missingProviderInfo.split(':')
            this.placesID = placesIDArray[1]
            // this has a provider assigned as well. it may be missing information
          }
        }
      }
    },
    userSearchResults() {
      if (!this.userPatientMatch.length > 0) {
        this.createUserPatientMatch()
      }
      this.oneChartUsers = this.userSearchResults.length
    },
    patientSearchResults() {
      this.oneChartPatients = this.patientSearchResults
      this.smartChoiceCount = 0
      this.grayhawkCount = 0
      this.imagineMDCount = 0
      this.smartChoiceToday = 0
      this.smartChoice7Days = 0
      this.smartChoiceThisMonth = 0
      this.smartChoiceUserCount = 0
      this.smartChoiceUsersThisMonth = []

      this.smartChoiceUsers = []

      let todayCuttoffDate = new Date()
      todayCuttoffDate.setHours(0, 0, 0, 0)
      let todayCuttoff = todayCuttoffDate.getTime() / 1000

      let sevenDayCutoff = todayCuttoffDate.getTime() / 1000
      sevenDayCutoff = sevenDayCutoff - 604800

      let thisMonthCutOff = this.getTimestampOfStartOfThisMonth()

      let previousMonthCutOff = this.getTimestampOfStartOfPreviousMonth()

      this.patientSearchResults.forEach(patient => {
        if (patient.creator) {
          if (!this.userIDsOfCreatorsOfPatients.includes(patient.creator.id)) {
            this.userIDsOfCreatorsOfPatients.push(patient.creator.id)
          }
        }
        if (patient.partner) {
          if (patient.partner.id === '5a4fa82c8e4b74e028665d04') {
            this.smartChoiceCount = this.smartChoiceCount + 1
            if (patient.creator) {
              if (!this.smartChoiceUsers.includes(patient.creator)) {
                if (patient.creator.email) {
                  if (!this.smartChoiceUsers.includes(patient.creator.email)) {
                    this.smartChoiceUsers.push(patient.creator.email)
                  }
                }
                if (patient.creator.created) {
                  if (patient.creator.created > thisMonthCutOff) {
                    if (
                      !this.smartChoiceUsersThisMonth.includes(
                        patient.creator.email
                      )
                    ) {
                      this.smartChoiceUsersThisMonth.push(patient.creator.email)
                    }
                    if (patient.creator.created > sevenDayCutoff) {
                      if (
                        !this.smartChoiceUsersLastWeek.includes(
                          patient.creator.email
                        )
                      ) {
                        this.smartChoiceUsersLastWeek.push(
                          patient.creator.email
                        )
                      }
                    }
                  } else if (patient.creator.created > previousMonthCutOff) {
                    if (
                      !this.smartChoiceUsersLastMonth.includes(
                        patient.creator.email
                      )
                    ) {
                      this.smartChoiceUsersLastMonth.push(patient.creator.email)
                    }
                  }
                }
              }
            }
            if (patient.creator) {
            }
            if (patient.created > todayCuttoff) {
              this.smartChoiceToday = this.smartChoiceToday + 1
            }
            if (patient.created > sevenDayCutoff) {
              this.smartChoice7Days = this.smartChoice7Days + 1
            }
          }
          if (patient.partner.id === '5acb94000495d7065c909bc2') {
            this.grayhawkCount = this.grayhawkCount + 1
          }
          if (patient.partner.id === '5b73507c4aef2028740f662b') {
            this.imagineMDCount = this.imagineMDCount + 1
          }
        } else {
          if (!this.nonPartnerPatients.includes(patient)) {
            this.nonPartnerPatients.push(patient)
            if (patient.creator) {
              if (
                !this.userCreatorsOfNonPartnerPatients.includes(patient.creator)
              ) {
                this.userCreatorsOfNonPartnerPatients.push(patient.creator)
              }
            }
          }
        }
      })

      this.numberOfPatients = this.smartChoiceCount
      this.smartChoiceUserCount = this.smartChoiceUsers.length
      if (!this.userPatientMatch.length > 0) {
        this.createUserPatientMatch()
      }
    }
  },
  created() {
    const vm = this
    vm.requestID = vm.$route.params.id
  },
  mounted() {
    // const vm = this

    // vm.getRequest(this.$route.params.id).then(() => {
    //   this.getRequestOverrides({ id: this.$route.params.id }).then(data => {
    //   })
    // })

    // vm.getDocumentFiles({ requestID: vm.$route.params.id }).then(() => {})
  }
  // TODO: Clear files from store
}
</script>

<style lang="scss" scoped>
.messages {
  height: calc(100vh - 256px);
  width: 100%;
}
.centered {
  position: fixed;
  top: 35%;
  left: 50%;
}

.grayAlternate {
  background-color: #ffffff;
}
.whiteAlternate {
  background-color: #fafafc;
}

.logs {
  font-size: 15px;
  font-weight: 400;
  color: black;
}
.admin-title {
  font-size: 18px;
  font-weight: 400;
  color: black;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.admin-title-bold {
  font-size: 18px;
  font-weight: 600;
  color: black;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.admin-sub-title {
  font-size: 16px;
  font-weight: 650;
  color: black;
}

.table-border {
  border: 1px solid #e6e6e8;
}
.publicWarning {
  background-color: red;
}

.normalInputColor {
  background-color: #eeeeee;
}

.headerTabUnselected {
  font-size: 30px;
  font-weight: 700;
  color: black;
  opacity: 0.2;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}
.headerTabSelected {
  font-size: 30px;
  font-weight: 700;
  color: black;
  cursor: pointer;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.blue-back {
  background: white;
}

.account-title {
  font-size: 24px;
  line-height: 30px;
  color: white;
}

.outline {
  border: 1px solid #eeeeee;
}

.provider-title {
  font-size: 17px;
  font-weight: 650;
  color: black;
}

.provider-name {
  font-size: 17px;
  font-weight: 450;
  color: black;
}

.card-title {
  font-size: 18px;
  font-weight: 400;
  color: black;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.card-title-bold {
  font-size: 16px;
  font-weight: 700;
  color: black;
  margin-right: 10px;
  transition: 0.4s;
  border-bottom: 2px solid transparent;
}

.card-content {
  text-align: right;
  font-size: 16px;
  font-weight: 400;
  color: black;
}

.card-sub-content {
  font-size: 16px;
  font-weight: 350;
  color: black;
}

.files-card {
  background-color: #f8f8f84d;
}

.files-card:hover {
  background-color: #f8f8f8;
}

.files-card:active {
  background-color: #efeff0;
}

.c-admin-title {
  font-size: 17px;
  font-weight: 650;
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/pages/admin/AdminRequestDetailPage.vue